module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "login"
    }
  }, [_c('div', {
    staticClass: "login-logo"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/logo_s.png")
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "inline-block",
      "margin-left": "10px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.gname)
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('mu-paper', {
    staticClass: "demo-paper",
    attrs: {
      "zDepth": 1
    }
  }, [_c('div', {
    staticClass: "login-title"
  }, [_c('div', {
    staticClass: "login-tm"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/images/logo-font.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "login-terminal"
  }, [_c('div', [_vm._v("|")]), _vm._v("医生登录")])]), _vm._v(" "), _c('div', {
    staticClass: "login-content"
  }, [_c('div', [_c('mu-text-field', {
    attrs: {
      "hintText": "登录名/手机号"
    },
    model: {
      value: (_vm.user.username),
      callback: function($$v) {
        _vm.$set(_vm.user, "username", $$v)
      },
      expression: "user.username"
    }
  })], 1), _vm._v(" "), _c('div', [_c('mu-text-field', {
    attrs: {
      "type": "password",
      "hintText": "密码"
    },
    model: {
      value: (_vm.user.password),
      callback: function($$v) {
        _vm.$set(_vm.user, "password", $$v)
      },
      expression: "user.password"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasSubmitted && !_vm.isValid),
      expression: "hasSubmitted && !isValid"
    }],
    staticClass: "danger"
  }, [_vm._v(_vm._s(_vm.error))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.authError),
      expression: "authError"
    }],
    staticClass: "danger"
  }, [_vm._v(_vm._s(_vm.errorMessage))]), _vm._v(" "), _c('div', [_c('mu-raised-button', {
    staticClass: "demo-raised-button",
    attrs: {
      "label": "登录",
      "primary": ""
    },
    on: {
      "click": _vm.login
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "login-forget"
  }, [_c('router-link', {
    staticStyle: {
      "color": "#999"
    },
    attrs: {
      "to": "/reset"
    }
  }, [_vm._v("忘记密码")]), _vm._v(" | "), _c('a', {
    staticStyle: {
      "color": "rgb(153, 153, 153)"
    },
    attrs: {
      "href": "https://www.66nao.com/faq/",
      "target": "_blank"
    }
  }, [_vm._v("常见问题")])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chose-chrome"
  }, [_c('h2', [_vm._v("推荐设备说明")]), _vm._v(" "), _c('dl', [_c('dt', [_vm._v("六六脑是严肃、专业的脑认知训练系统，为确保系统稳定性和训练效果，请您确保使用以下2类推荐设备：")]), _vm._v(" "), _c('dd', [_vm._v("•电脑，包含一体机。如果您使用Windows系统的电脑（配置要求：操作系统64位），请使用"), _c('span', {
    staticClass: "bold-mark"
  }, [_vm._v("Chrome")]), _vm._v("浏览（"), _c('a', {
    staticClass: "link-mark",
    attrs: {
      "id": "download",
      "href": "https://www.66nao.com/faq/source_package/chrome.rar"
    }
  }, [_vm._v("点击下载")]), _vm._v("，查看"), _c('a', {
    staticClass: "link-mark",
    attrs: {
      "href": "https://www.66nao.com/faq/pages/question.1.html",
      "target": "_blank"
    }
  }, [_vm._v("下载安装说明")]), _vm._v("。如果您在使用Chrome浏览器时无法正常训练，请尝试卸载后重新安装我们提供的Chrome浏览器。）；如果是macOS系统，请使用自带的"), _c('span', {
    staticClass: "bold-mark"
  }, [_vm._v("Safari")]), _vm._v("浏览器 。​")]), _vm._v(" "), _c('dd', [_vm._v("•平板，推荐苹果 "), _c('span', {
    staticClass: "bold-mark"
  }, [_vm._v("iPad2017")]), _vm._v(" 和 "), _c('span', {
    staticClass: "bold-mark"
  }, [_vm._v("iPad2018")]), _vm._v(" 。请使用设备自带的"), _c('span', {
    staticClass: "bold-mark"
  }, [_vm._v("Safari")]), _vm._v("浏览器 。")]), _vm._v(" "), _c('dt', [_vm._v("注：手机、安卓平板等设备因屏幕小、型号多，易造成不可控的稳定性和使用问题，不建议使用。")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-65cbf58a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/login.vue
// module id = 998
// module chunks = 2